/**
 * SOFYRE Homepage JavaScript v1.0
 * Countdown · Announcement Bar · Sticky Header · Scroll Animations · FAQ · Mobile Nav
 */
(function () {
  'use strict';

  /* ── 1. COUNTDOWN TIMER ─────────────────────────────────────
     24-hour countdown stored in sessionStorage so it persists
     across page navigations but resets on browser close.
  ─────────────────────────────────────────────────────────── */
  function initCountdown() {
    var el = document.getElementById('sofyre-countdown');
    if (!el) return;

    var KEY = 'sofyre_countdown_end';
    var DURATION = 24 * 60 * 60 * 1000;
    var end = parseInt(sessionStorage.getItem(KEY), 10);

    if (!end || isNaN(end)) {
      end = Date.now() + DURATION;
      sessionStorage.setItem(KEY, end);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + DURATION;
        sessionStorage.setItem(KEY, end);
        left = DURATION;
      }
      var s = Math.floor(left / 1000);
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ── 2. ANNOUNCEMENT BAR CLOSE ──────────────────────────── */
  function initAnnouncementBar() {
    var bar = document.getElementById('sofyre-announcement-bar');
    var btn = document.querySelector('.sofyre-bar-close');
    var KEY = 'sofyre_bar_closed';

    if (!bar) return;

    if (sessionStorage.getItem(KEY) === 'true') {
      bar.style.display = 'none';
      return;
    }

    if (btn) {
      btn.addEventListener('click', function () {
        bar.style.display = 'none';
        sessionStorage.setItem(KEY, 'true');
      });
    }
  }

  /* ── 3. STICKY HEADER ───────────────────────────────────── */
  function initStickyHeader() {
    var header =
      document.querySelector('.shopify-section-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('header.header') ||
      document.querySelector('header') ||
      document.querySelector('#shopify-section-header');

    if (!header) return;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('sofyre-header--scrolled', window.scrollY > 60);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── 4. SCROLL ANIMATIONS ───────────────────────────────── */
  function initScrollAnimations() {
    var els = document.querySelectorAll('.sofyre-fade-up');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── 5. FAQ ACCORDION ───────────────────────────────────── */
  function initFaqAccordion() {
    var btns = document.querySelectorAll('.sofyre-faq-q');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var ans  = btn.nextElementSibling;

        // Close all others
        btns.forEach(function (b) {
          if (b !== btn) {
            b.setAttribute('aria-expanded', 'false');
            var a = b.nextElementSibling;
            if (a && a.classList.contains('sofyre-faq-a')) a.hidden = true;
          }
        });

        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (ans) ans.hidden = open;
      });
    });
  }

  /* ── 6. MOBILE NAV DRAWER ───────────────────────────────── */
  function initMobileNav() {
    var hamburger = document.querySelector('.sofyre-hamburger');
    var overlay   = document.querySelector('.sofyre-nav-overlay');
    var closeBtn  = document.querySelector('.sofyre-mobile-nav-close');

    function open()  { document.body.classList.add('sofyre-nav-open');    document.body.style.overflow = 'hidden'; }
    function close() { document.body.classList.remove('sofyre-nav-open'); document.body.style.overflow = ''; }

    if (hamburger) hamburger.addEventListener('click', function () {
      document.body.classList.contains('sofyre-nav-open') ? close() : open();
    });
    if (overlay)  overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('sofyre-nav-open')) close();
    });
  }

  /* ── INIT ────────────────────────────────────────────────── */
  function init() {
    initAnnouncementBar();
    initCountdown();
    initStickyHeader();
    initScrollAnimations();
    initFaqAccordion();
    initMobileNav();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
